import { FC } from 'react';
import { Button, DefaultContentComponent, Popup } from '@silverfort/sf-components';

interface Props {
    open: boolean;
    handleConfirm: VoidFunction;
    handleClose: VoidFunction;
}

const FooterComponent: FC<Pick<Props, 'handleConfirm'>> = ({ handleConfirm }) => {
    return (
        <div className="flex flex-row flex-1 justify-end">
            <Button text="Confirm" onClick={handleConfirm} />
        </div>
    );
};

const Fido2ModeChangedPopup: FC<Props> = ({ open, handleConfirm, handleClose }) => {
    return (
        <Popup
            open={open}
            title="Warning"
            ContentComponent={DefaultContentComponent}
            ContentComponentProps={{
                text: 'Switching modes may potentially invalidate any previously paired FIDO2 tokens, requiring them to be paired again.'
            }}
            FooterComponent={FooterComponent}
            FooterComponentProps={{ handleConfirm }}
            onClose={handleClose}
            popupClassName="w-[360px] h-[240px]"
        />
    );
};

export default Fido2ModeChangedPopup;
